// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import PropTypes from "prop-types";

// IDP React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDProgress from "components/MDProgress";

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // <-- tambahkan ini
import { APIClient } from "services/api";

const apiClient = new APIClient();

export default function data() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // <-- inisialisasi navigate

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const documents = await apiClient.listDocuments();
        setDocuments(documents);
      } catch (error) {
        console.error("Error fetching documents:", error);
        setDocuments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDocuments();
  }, []);

  const handleReview = (id) => {
    console.log("Review document:", id);
  };

  const handleDownload = (id) => {
    console.log("Download document:", id);
  };

  const handleDelete = (id) => {
    console.log("Delete document:", id);
  };

  const Status = ({ status }) => (
    <MDBox display="flex" alignItems="center">
      <MDBox mr={1}>
        <MDTypography
          variant="button"
          fontWeight="medium"
          color={
            status === "Processing"
              ? "warning"
              : status === "Completed"
              ? "info"
              : status === "Review"
              ? "info"
              : "error"
          }
        >
          {status}
        </MDTypography>
      </MDBox>
      {status === "Processing" && <MDProgress variant="gradient" color="warning" value={40} />}
    </MDBox>
  );

  Status.propTypes = {
    status: PropTypes.oneOf(["Processing", "Review", "Processed", "Completed"]).isRequired,
  };

  const Action = ({ id }) => (
    <MDBox display="flex" alignItems="center">
      <MDBox mr={1}>
        <Tooltip title="Detail & Approve">
          <Icon
            fontSize="small"
            color="inherit"
            onClick={() => navigate(`/document-approval/${id}`)}
            sx={{ cursor: "pointer" }}
          >
            edit
          </Icon>
        </Tooltip>
      </MDBox>
      <MDBox mr={1}>
        <Tooltip title="Download Document">
          <Icon
            fontSize="small"
            color="inherit"
            onClick={() => handleDownload(id)}
            sx={{ cursor: "pointer" }}
          >
            download
          </Icon>
        </Tooltip>
      </MDBox>
      <Tooltip title="Delete Document">
        <Icon
          fontSize="small"
          color="error"
          onClick={() => handleDelete(id)}
          sx={{ cursor: "pointer" }}
        >
          delete
        </Icon>
      </Tooltip>
    </MDBox>
  );

  Action.propTypes = {
    id: PropTypes.string.isRequired,
  };

  return {
    columns: [
      { Header: "name", accessor: "name", width: "30%", align: "left" },
      { Header: "status", accessor: "status", align: "left" },
      { Header: "uploaded by", accessor: "author", align: "center" },
      { Header: "Status Approval", accessor: "status_approval", align: "center" },
      { Header: "date modified", accessor: "dateModified", align: "center" },
      { Header: "date added", accessor: "dateAdded", align: "center" },
      { Header: "action", accessor: "action", align: "center" },
    ],

    rows: loading
      ? [
          {
            name: "Loading...",
            status: <Status status="Processing" />,
            author: "--",
            dateModified: "--",
            dateAdded: "--",
            action: <Action id="loading" />,
          },
        ]
      : documents.map((doc) => ({
          name: doc.name || "Untitled",
          status: <Status status={doc.status || "Processing"} />,
          author: doc.uploaded_by || "Unknown",
          status_approval: doc.status_approval || "Waiting for Review",
          dateModified: doc.modified_at ? new Date(doc.modified_at).toLocaleString() : "--",
          dateAdded: doc.created_at ? new Date(doc.created_at).toLocaleString() : "--",
          action: <Action id={doc.id ? doc.id.toString() : "0"} />,
        })),
  };
}
